import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const TamamlayiciSaglikSeo = () => {
  const fiyatlar = {
    'İstanbul': {
      '25-34': { kadin: '13.280 TL', erkek: '11.653 TL' },
      '35-44': { kadin: '13.694 TL', erkek: '12.154 TL' },
      '45-54': { kadin: '15.618 TL', erkek: '12.138 TL' },
      '55-64': { kadin: '19.785 TL', erkek: '16.125 TL' }
    },
    'Ankara': {
      '25-34': { kadin: '12.044 TL', erkek: '9.062 TL' },
      '35-44': { kadin: '12.943 TL', erkek: '12.336 TL' },
      '45-54': { kadin: '17.178 TL', erkek: '12.889 TL' },
      '55-64': { kadin: '19.596 TL', erkek: '12.513 TL' }
    },
    'İzmir': {
      '25-34': { kadin: '12.846 TL', erkek: '11.574 TL' },
      '35-44': { kadin: '11.864 TL', erkek: '9.497 TL' },
      '45-54': { kadin: '12.371 TL', erkek: '11.263 TL' },
      '55-64': { kadin: '15.130 TL', erkek: '12.137 TL' }
    },
    'Kocaeli': {
      '25-34': { kadin: '10.875 TL', erkek: '9.456 TL' },
      '35-44': { kadin: '10.688 TL', erkek: '9.344 TL' },
      '45-54': { kadin: '11.876 TL', erkek: '11.537 TL' },
      '55-64': { kadin: '12.128 TL', erkek: '12.377 TL' }
    }
  };

  const schema = {
    "@context": "https://schema.org",
    "@type": "Insurance",
    "name": "Tamamlayıcı Sağlık Sigortası",
    "description": "En uygun tamamlayıcı sağlık sigortası tekliflerini anında karşılaştırın. SGK ile anlaşmalı özel hastanelerde fark ücreti ödemeden tedavi olun.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "750"
    }
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Tamamlayıcı Sağlık Sigortası Nedir?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Tamamlayıcı sağlık sigortası; SGK ile anlaşmalı özel hastanelerde kullanılan, SGK fark ücreti ödemeden %100 sağlık hizmeti almayı sağlayan bir sağlık sigortası türüdür."
        }
      },
      {
        "@type": "Question",
        "name": "Kimler tamamlayıcı sağlık sigortası alabilir?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "0-70 arasında SGK'lı olan herkes tamamlayıcı sağlık sigortası alabilir. Bebekler doğum tarihinden itibaren 15 gün sonra poliçe kapsamına alınabilir."
        }
      }
    ]
  };

  return (
    <>
      <Helmet>
        <title>Tamamlayıcı Sağlık Sigortası Fiyatları ve Teminatları | SigortamOlsun</title>
        <meta name="description" content="Tamamlayıcı sağlık sigortası ile SGK anlaşmalı özel hastanelerde fark ücreti ödemeden tedavi olun. En uygun TSS fiyatları için hemen teklif alın!" />
        <meta name="keywords" content="tamamlayıcı sağlık sigortası, tss, sağlık sigortası, özel hastane" />
        <link rel="canonical" href="https://sigortamolsun.com/tamamlayici-saglik" />
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>

      <div className="max-w-5xl mx-auto px-4 py-8 md:py-12">
        {/* Ana Başlık ve Açıklama */}
        <section className="mb-12">
          <h1 className="text-3xl font-bold mb-6">Tamamlayıcı Sağlık Sigortası</h1>
          <div className="prose max-w-none">
            <p className="text-lg text-gray-600">
              Tamamlayıcı sağlık sigortası (TSS), SGK ile anlaşması olan özel hastanelerde fark ücreti ödemeden sağlık hizmeti alabileceğiniz sağlık sigortasıdır. SGK'nın kapsadığı ücret limitlerini aşan tedavi giderlerini karşılayarak ilave ücret ödemeden tedavi olmanızı sağlar.
            </p>
          </div>
        </section>

        {/* Fiyat Tablosu */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold mb-6">2025 Tamamlayıcı Sağlık Sigortası Fiyatları</h2>
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border border-gray-200 shadow-sm rounded-lg">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 border-b text-left text-sm font-semibold text-gray-600">Şehir</th>
                  <th className="px-4 py-3 border-b text-left text-sm font-semibold text-gray-600">Yaş Aralığı</th>
                  <th className="px-4 py-3 border-b text-right text-sm font-semibold text-gray-600">Kadın</th>
                  <th className="px-4 py-3 border-b text-right text-sm font-semibold text-gray-600">Erkek</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(fiyatlar).map(([sehir, yasAraliklari]) => (
                  Object.entries(yasAraliklari).map(([yasAraligi, { kadin, erkek }]) => (
                    <tr key={`${sehir}-${yasAraligi}`} className="hover:bg-gray-50">
                      <td className="px-4 py-3 border-b">{sehir}</td>
                      <td className="px-4 py-3 border-b">{yasAraligi}</td>
                      <td className="px-4 py-3 border-b text-right">{kadin}</td>
                      <td className="px-4 py-3 border-b text-right">{erkek}</td>
                    </tr>
                  ))
                ))}
              </tbody>
            </table>
          </div>
          <p className="text-sm text-gray-500 mt-4">
            * Fiyatlar 2025 Ocak Ayı tahmini TSS teklifleri verilerine dayanmaktadır. 
            Kişiye göre ve sigorta şirketinin risk değerlendirmesine göre değişiklik gösterebilir.
          </p>
        </section>

        {/* Teminatlar */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold mb-6">Tamamlayıcı Sağlık Sigortası Teminatları</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
              <h3 className="font-semibold mb-3">Yatarak Tedavi Teminatı</h3>
              <ul className="text-gray-600 text-sm space-y-2">
                <li>• Ameliyat ve Hastane Yatışları</li>
                <li>• Yoğun Bakım</li>
                <li>• Kemoterapi ve Radyoterapi</li>
                <li>• Diyaliz Tedavileri</li>
              </ul>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
              <h3 className="font-semibold mb-3">Ayakta Tedavi Teminatı</h3>
              <ul className="text-gray-600 text-sm space-y-2">
                <li>• Doktor Muayeneleri</li>
                <li>• Laboratuvar Tetkikleri</li>
                <li>• Görüntüleme İşlemleri</li>
                <li>• Fizik Tedavi</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="mb-12">

        <div className="prose max-w-none space-y-8">
  <div>
    <h3 className="text-xl font-semibold mb-3">Neden Tamamlayıcı Sağlık Sigortası Yaptırmalıyız?</h3>
    <p className="text-gray-600">
      Tamamlayıcı sağlık sigortası; hastalık, kaza veya sağlıkla ilgili diğer ihtiyaç duyulabilecek hizmetlerden 1 yıl boyunca maliyetleri düşünmeden faydalanmanızı sağlar. Başlıca avantajları:
    </p>
    <ul className="list-disc pl-5 space-y-2 text-gray-600">
      <li>Ameliyat, hastanede yatış, kemoterapi, yoğun bakım ve diğer hastanede yatmayı gerektiren durumlarda hastaneye hiçbir ücret ödemezsiniz.</li>
      <li>Doktor muayenesi, laboratuvar tetkikleri ve görüntüleme işlemleri için hastaneye sadece 50 TL SGK katılım payı ücreti ödersiniz.</li>
      <li>Her yıl düzenli sağlık kontrolü için check-up ve diş bakım paketi imkanı</li>
      <li>Online doktor görüşmesi hizmeti</li>
    </ul>
  </div>
</div>
  </section>

        {/* SSS */}
        <section className="mb-12 bg-gradient-to-br from-blue-50 to-purple-50 -mx-4 p-8">
          <h2 className="text-2xl font-bold mb-6">Sıkça Sorulan Sorular</h2>
          <div className="space-y-6">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
              <h3 className="font-semibold mb-3">Tamamlayıcı Sağlık Sigortası SGK Şart mı?</h3>
              <p className="text-gray-600 text-sm">
                Evet, SGK'lı olma şartı vardır. Çünkü tamamlayıcı sağlık sigortası SGK'dan kalan fark ücretini karşılayan bir ek sağlık sigortasıdır.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
              <h3 className="font-semibold mb-3">Tamamlayıcı Sağlık Sigortası Yaş Sınırı Var mıdır?</h3>
              <p className="text-gray-600 text-sm">
                0-70 yaş arasında SGK'lı olan herkes tamamlayıcı sağlık sigortası alabilir. 70 yaş üstü kişiler için özel şartlar geçerlidir.
              </p>
            </div>

            <div className="space-y-6">
  <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
    <h3 className="font-semibold mb-3">Tamamlayıcı sağlık sigortası nasıl yapılır?</h3>
    <p className="text-gray-600 text-sm">
      TSS yaptırmak için şu adımları izleyebilirsiniz:
      <ol className="list-decimal pl-5 mt-2 space-y-1">
        <li>Formumuzu doldurarak fiyat talebinde bulunun.</li>
        <li>Sigorta danışmanlarımız size özel teklifleri sunmak için sizi arayacak.</li>
      </ol>
    </p>
  </div>

  <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
    <h3 className="font-semibold mb-3">Tamamlayıcı sağlık sigortası neleri kapsar?</h3>
    <p className="text-gray-600 text-sm">
      TSS kapsamında yatarak tedavi teminatı, ayakta tedavi teminatı, doğum teminatı ve ek teminatlar yer alır. Acil hastalık durumunda ihtiyaç duyulan tüm hizmetler, doktor muayenesi, laboratuvar işlemleri ve ameliyat masrafları poliçe kapsamındadır.
    </p>
  </div>

  <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
    <h3 className="font-semibold mb-3">Tamamlayıcı sağlık sigortası acilde geçerli mi?</h3>
    <p className="text-gray-600 text-sm">
      Evet, tamamlayıcı sağlık sigortası acil durumlarda da geçerlidir. SGK anlaşmalı tüm özel hastanelerin acil servislerinde fark ücreti ödemeden hizmet alabilirsiniz.
    </p>
  </div>


</div>

<section className="mb-12">
  <h2 className="text-2xl font-bold mb-6">Avantajlar ve Ek Hizmetler</h2>
  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
      <h3 className="font-semibold mb-3">Check-up Paketi</h3>
      <p className="text-gray-600 text-sm">
        Yıllık düzenli sağlık kontrolleriniz için ücretsiz check-up hizmeti.
      </p>
    </div>
    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
      <h3 className="font-semibold mb-3">Online Doktor</h3>
      <p className="text-gray-600 text-sm">
        Hastaneye gitmeden önce online doktor görüşmesi ve tavsiye alma imkanı.
      </p>
    </div>
    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
      <h3 className="font-semibold mb-3">Diş Bakım Paketi</h3>
      <p className="text-gray-600 text-sm">
        Diş sağlığınız için özel bakım paketi ve indirimli hizmetler.
      </p>
    </div>
  </div>
</section>

          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default TamamlayiciSaglikSeo;